import React from "react";
import {
  makeStyles,
  Theme,
  createStyles,
  IconButton,
  Paper,
} from "@material-ui/core";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import AddBoxIcon from "@material-ui/icons/AddBox";
import { ScheduleSelect, ScheduleSelectData } from "./ScheduleSelect";

/** スタイル定義 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
    },
    left: {},
    right: {
      marginLeft: "0.25rem",
      display: "flex",
      flexDirection: "column",
    },
    paper: {
      display: "flex",
      margin: "0.25rem",
      paddingRight: "0.25rem",
    },
    iconDelete: {
      marginTop: 5,
      height: "2.9rem",
    },
  })
);

interface Props {
  data: ScheduleSelectData[];
  handlePeriodChange?:
    | ((
        event: React.ChangeEvent<{
          name?: string | undefined;
          value: unknown;
        }>,
        child: React.ReactNode,
        key?: string | number | undefined
      ) => void)
    | undefined;
  handleWeekdayChange?:
    | ((
        event: React.ChangeEvent<{
          name?: string | undefined;
          value: unknown;
        }>,
        child: React.ReactNode,
        key?: string | number | undefined
      ) => void)
    | undefined;
  handleHourChange?:
    | ((
        event: React.ChangeEvent<{
          name?: string | undefined;
          value: unknown;
        }>,
        child: React.ReactNode,
        key?: string | number | undefined
      ) => void)
    | undefined;
  handleMinuteChange?:
    | ((
        event: React.ChangeEvent<{
          name?: string | undefined;
          value: unknown;
        }>,
        child: React.ReactNode,
        key?: string | number | undefined
      ) => void)
    | undefined;
  handleRowAddClick: (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  handleRowDeleteClick: (
    uuid: string,
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    rowData: ScheduleSelectData
  ) => void;
}

/** スケジュール選択セット */
export function ScheduleSelectSet(props: Props) {
  const classes = useStyles();

  const {
    data,
    handlePeriodChange,
    handleWeekdayChange,
    handleHourChange,
    handleMinuteChange,
    handleRowAddClick,
    handleRowDeleteClick,
  } = props;

  //--------------------
  // コンポーネント
  return (
    <div className={classes.container}>
      <div className={classes.left}>
        <IconButton aria-label="add" onClick={handleRowAddClick}>
          <AddBoxIcon />
        </IconButton>
      </div>
      <div className={classes.right}>
        {data.map((rowData: ScheduleSelectData) => {
          // 新規追加の場合は独自にuuidを設定する
          return (
            <Paper
              key={`scheduleSelectDiv-${rowData.uuid}`}
              className={classes.paper}
            >
              <ScheduleSelect
                data={rowData}
                groupId={rowData.uuid}
                handlePeriodChange={handlePeriodChange}
                handleWeekdayChange={handleWeekdayChange}
                handleHourChange={handleHourChange}
                handleMinuteChange={handleMinuteChange}
              />
              <div>
                <IconButton
                  className={classes.iconDelete}
                  aria-label="delete"
                  onClick={e => handleRowDeleteClick(rowData.uuid, e, rowData)}
                >
                  <DeleteOutlineIcon />
                </IconButton>
              </div>
            </Paper>
          );
        })}
      </div>
    </div>
  );
}
